export default __webpack_public_path__ + "static/media/It's about to go down.fde6a5af.mp4";